import { Heading, TextProps } from "@chakra-ui/react";
import { PropsWithChildren } from "react";

export const HeaderText = ({ children, ...props }: PropsWithChildren & TextProps) => (
  <Heading fontWeight="700" size="2xl" {...props}>
    {children}
  </Heading>
);
